<template>
    <div id="admin_rules_page" class="container-fluid">
        <h4 class="margin-left10 margin-bottom20 pull-left">Client: {{ client.name || 'All Clients' }}</h4>
        <button v-if="$store.getters.getAuthUser.original.user_type_id === 0" @click="resetModalData" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_rule">+ Add New Rule</button>

        <div class="modal fade" id="add_new_rule" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add New Rule</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <label class="w-100 margin-bottom0">Name:</label>
                        <input id="rule_name" v-model="rule_name" type="text" class="form-control">

                        <label class="w-100 margin-bottom0 margin-top10">Reporting Table Type:</label>
                        <v-select :clearable="false" v-model="reporting_table_type_id" :reduce="reporting_table_type => reporting_table_type.id" label="type" :options="reporting_table_types"></v-select>

                        <label class="w-100 margin-bottom0 margin-top10">Rule:</label>
                        <input id="new_rule" v-model="new_rule" type="text" class="form-control">
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewRule" :disabled="!rule_name || !new_rule" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="rule" slot-scope="props">
                <div class="margin-y10" v-if="!props.row.edit_mode">{{ props.row.rule }}</div>
                <input v-if="props.row.edit_mode" type="text" class="form-control edit-rule w-100" :value="props.row.rule">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <button v-if="$store.getters.getAuthUser.original.user_type_id === 0 && !props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn btn-info reverse">Edit</button>
                <button v-if="$store.getters.getAuthUser.original.user_type_id === 0 && props.row.edit_mode" @click="save(props.row.id, $event)" class="btn btn-success reverse">Save</button>
                <button v-if="$store.getters.getAuthUser.original.user_type_id === 0 && props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn cancel-editing">Cancel</button>
                <button v-if="$store.getters.getAuthUser.original.user_type_id === 0 && !props.row.edit_mode" @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            if (this.$route.params.id) {
                axios.get(`/api/clients/${this.$route.params.id}`).then(response => {
                    this.client = response.data;
                });
            }

            this.fetchServerData();
        },

        data() {
            return {
                client:                  {},
                reporting_table_types:   [],
                reporting_table_type_id: null,
                rule_name:               '',
                new_rule:                '',

                columns: ['rule_name', 'reporting_table_type', 'rule', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        rule_name:            'Rule Name',
                        reporting_table_type: 'Reporting Table Type',
                        rule:                 'Rule',
                        actions:              ''
                    },
                    sortable: ['rule_name', 'reporting_table_type', 'rule'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} rules|{count} rules|One rule',
                        filter: '',
                        filterPlaceholder: 'Search rules...',
                        noResults: 'No matching rules'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/admin/rules?client_id=${this.$route.params.id || ''}`),
                    axios.get('/api/reporting-table-types')
                ])
                .then(axios.spread((rules, reportingTableTypes) => {
                    _.each(rules.data, item => {
                        item.edit_mode = false;
                    });

                    this.tableData               = rules.data;
                    this.reporting_table_types   = Object.values(reportingTableTypes.data);
                    this.reporting_table_type_id = reportingTableTypes.data[0].id;
                }));
            },

            resetModalData() {
                this.reporting_table_type_id = this.reporting_table_types[0].id;
                this.rule_name               = '';
                this.new_rule                = '';
            },

            addNewRule() {
                $('#add_new_rule').modal('hide');

                axios.post(`/api/admin/rules?client_id=${this.$route.params.id || ''}`, {
                    rule_name:               this.rule_name,
                    reporting_table_type_id: this.reporting_table_type_id,
                    rule:                    this.new_rule
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Rule has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            toggleEditMode(id) {
                const index = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = !this.tableData[index].edit_mode;
                }
            },

            save(id, event) {
                const newRule = $(event.target).closest('tr').find('.edit-rule').val();
                const index   = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = false;
                }

                axios.put(`/api/admin/rules/${id}?client_id=${this.$route.params.id || ''}`, {
                    rule_name:               this.tableData[index].rule_name,
                    reporting_table_type_id: this.tableData[index].reporting_table_type_id,
                    rule:                    newRule
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Rule has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this rule?', () => {
                    axios.delete(`/api/admin/rules/${id}?client_id=${this.$route.params.id || ''}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Rule has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #admin_rules_page {
        .edit-rule {
            width: auto;
            height: 3.4rem;
        }

        .cancel-editing {
            padding: 0.8rem 1.65rem;
        }

        label {
            font-size: 1.3rem;
        }

        input[type="radio"] {
            position: relative;
            top: .1rem;
        }

        .VueTables__search {
            display: none;
        }

        .VueTables__table {
            table-layout: fixed;
        }
    }
</style>
